import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function getAllUsers(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const params = new URLSearchParams({
      limit: String(payload.pageSize || 25),
      search: payload.search || "",
      page: String(payload.pageNo || 0),
    });
    const orgId = String(payload?.organizationId || "").trim();
    if (orgId && orgId !== "all" && orgId !== "*") {
      params.set("organizationId", orgId);
    }
    const response = await makeCall(
      `${urls.GETALLLEADS}?${params.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function changeFormStatusApi(status: any, id: any) {
  const payload = {
    id: id,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.UPDATELEADDEFORMTAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}